import { useCallback, useState } from "react";

/**
 * Open state of CandleColorsModal plus the colours and shadow style
 * previewed on the chart while it is open. Closing the modal drops the preview, so the chart falls
 * back to the saved colours unless they were applied.
 *
 * @returns {{
 *   isOpen: boolean,
 *   open: () => void,
 *   close: () => void,
 *   preview: { candleUpColor: string, candleDownColor: string, shadowStyle: string } | null,
 *   setPreview: (preview: object | null) => void,
 * }}
 */
const useCandleColorsModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [preview, setPreview] = useState(null);

  const open = useCallback(() => setIsOpen(true), []);

  const close = useCallback(() => {
    setIsOpen(false);
    setPreview(null);
  }, []);

  return { isOpen, open, close, preview, setPreview };
};

export default useCandleColorsModal;
